<template>
  <Header></Header>
  <div><el-image :src="cp_dt"></el-image></div>
  <!-- 被子區 -->
  <!-- <div>
    <div class="bz-title">被子專區</div>
    <div class="bz-subtitle">
      新疆精梳棉为原料，具有柔软高透气性，高吸湿性等特性
    </div>
    <div class="bzcon">
      <div class="bz-left">
        <div class="bz-cltp"><el-image :src="cp2"></el-image></div>
        <div class="bz-clbt"><el-image :src="cp3"></el-image></div>
        <div class="bz-clms">
          精选优质棉花原料，斜纹印花工艺，高支高
          密，手感细腻，紧实细密，质感柔软，透气 吸湿，缩水率低
        </div>
      </div>
      <div class="bz-right">
        <div class="bz-shang">
          <div>
            <el-image class="bz-shang-tp" :src="bz[0]['url']"></el-image>
            <div class="bz-shang-wz">{{ bz[0]["des"] }}</div>
          </div>
          <div>
            <el-image class="bz-shang-tp" :src="bz[1]['url']"></el-image>
            <div class="bz-shang-wz">{{ bz[1]["des"] }}</div>
          </div>
        </div>
        <div class="bz-xia">
          <div>
            <el-image class="bz-xia-tp" :src="bz[2]['url']"></el-image>
            <div class="bz-xia-wz">{{ bz[2]["des"] }}</div>
          </div>
          <div>
            <el-image class="bz-xia-tp" :src="bz[3]['url']"></el-image>
            <div class="bz-xia-wz">{{ bz[3]["des"] }}</div>
          </div>
          <div>
            <el-image class="bz-xia-tp" :src="bz[3]['url']"></el-image>
            <div class="bz-xia-wz">{{ bz[3]["des"] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- 枕頭 -->
  <div>
    <div class="zt-title">枕頭專區</div>
    <div class="zt-subtitle">健康生活，舒适睡眠，安全监测适合各类人群</div>
        <div class="zt-shang">
      <div  v-for="item of zt" :key="item.index" >
        <el-image class="zt-shang-tp" :src="item.url"></el-image>
        <div class="zt-shang-wz">{{ item.prod_des }}</div>
      </div>
    </div>
  </div>

  <Footer></Footer>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "Cp",
  data() {
    return {
      company_sn:"R",
      cp_dt: "http://139.159.153.112:8200/gw_lmm/cp1.jpg",
      cp2: "http://139.159.153.112:8200/gw_lmm/cp2.png",
      cp3: "http://139.159.153.112:8200/gw_lmm/cp3.png",
      zt:[],
      bz: [
        {
          url: "http://139.159.153.112:8200/gw_lmm/cp/bz/1.png",
          des: "天竺棉夏凉被",
        },
        {
          url: "http://139.159.153.112:8200/gw_lmm/cp/bz/2.png",
          des: "天竺棉夏凉被",
        },
        {
          url: "http://139.159.153.112:8200/gw_lmm/cp/bz/3.png",
          des: "天竺棉夏凉被",
        },
        {
          url: "http://139.159.153.112:8200/gw_lmm/cp/bz/4.png",
          des: "天竺棉夏凉被",
        },
        {
          url: "http://139.159.153.112:8200/gw_lmm/cp/bz/5.png",
          des: "天竺棉夏凉被",
        },
      ],
      // zt: [
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/1.jpg",
      //     des: "蘆薈布床褥保潔墊",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/2.jpg",
      //     des: "蘆薈布枕套",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/3.jpg",
      //     des: "蘆薈布太空棉枕",
      //   },
      //   {
      //     url: "http://139.159.153.112:8200/gw_lmm/cp/zt/4.jpg",
      //     des: "蘆薈布舒適枕",
      //   },
      // ],
    };
  },
  components: { Header, Footer },
    created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.queryProdZT()
    }
  },
  methods:{
    // 查询推荐货品
    queryProdZT() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"B001",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.zt=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  }
};
</script>

<style scoped>
/* 被子專區 */
.bz-title {
  margin-top: 60px;
  font-size: 40px;
  color: rgb(51, 51, 51);
}
.bz-subtitle {
  font-size: 16px;
  line-height: 72px;
  color: rgb(51, 51, 51);
}
.bzcon {
  width: 1200px;
  display: flex;
  margin: 50px auto;
}
.bz-left {
  width: 300px;
  margin-right: 50px;
}
.bz-cltp {
  margin-top: 50px;
}
.bz-clbt {
  margin-top: 30px;
}
.bz-clms {
  margin-top: 30px;
  line-height: 30px;
}
.bz-right {
  width: 800px;
}
.bz-shang {
  display: flex;
  justify-content: space-around;
}
.bz-shang-tp {
  width: 380px;
  height: 380px;
}
.bz-shang-wz {
  position: relative;
  top: -25px;
  width: 300px;
  height: 50px;
  border: 1px solid #dcdcdc;
  margin: 0 auto;
  line-height: 50px;
  background: #ffffff;
}
.bz-xia {
  display: flex;
  justify-content: space-around;
}
.bz-xia {
  display: flex;
  justify-content: space-around;
}
.bz-xia-tp {
  width: 260px;
  height: 320px;
}
.bz-xia-wz {
  position: relative;
  top: -25px;
  width: 200px;
  height: 50px;
  border: 1px solid #dcdcdc;
  margin: 0 auto;
  line-height: 50px;
  background: #ffffff;
}

/* 枕頭 */
.zt-title {
  margin-top: 60px;
  font-size: 40px;
  color: rgb(51, 51, 51);
}
.zt-subtitle {
  font-size: 16px;
  line-height: 72px;
  color: rgb(51, 51, 51);
}

.zt-shang {
  width: 1400px;
  margin: 50px auto;
  display: flex;
  justify-content: space-around;
}
.zt-shang-tp {
  width: 300px;
  height: 200px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.zt-shang-wz {
  position: relative;
  width: 300px;
  height: 50px;
  margin: 0 auto;
  line-height: 50px;
  background: #ffffff;
}
</style>